<template>
  <div class="d-flex-row space-between lg-row-to-col">
    <HeroProficiencyPicker
      type="currentRank"
      :title="$t('calculators_common.current_rank')"
      :description="$t('calculators_common.current_rank')"
      class="flex-5 flex-lg-10"
      :show-server="false"
    />
    <DoubleRight />
    <HeroProficiencyPicker
      type="desiredRank"
      :title="$t('calculators_common.desired_rank')"
      :description="$t('calculators_common.desired_rank')"
      class="flex-5 flex-lg-10"
      :show-server="false"
      :prev-rank="checkoutStore.getDetails.currentRankSlab"
    />
  </div>
  <ExtraOptionPicker :options="['specific_hero', 'server']" />
  <OptionPicker />
  <PlatformPicker />
</template>

<script setup>
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";
import OptionPicker from "./pickers/OptionPicker.vue";
import HeroProficiencyPicker from "./pickers/HeroProficiencyPicker.vue";
import DoubleRight from "~/components/icons/DoubleRight.vue";
import PlatformPicker from "../commonpickers/PlatformPicker.vue";

const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();
const { currentGameSlug } = useGameComposable();

checkoutStore.clearCheckout();

const handleDetails = () => {
  checkoutStore.setPlatform({
    platform: 1,
  });

  const prices = gameStore.getGamePack.prices;

  if (prices.length > 0) {
    const details = {
      currentRank: prices[0].id,
      currentRankSlab: prices[0].slab,
      currentRankTitle: prices[0].title,
      desiredRank: prices[1].id,
      desiredRankSlab: prices[1].slab,
      desiredRankTitle: prices[1].title,
    };

    checkoutStore.setDetails({
      ...details,
    });
  }

  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
  checkoutStore.setServer(gameStore.getGame.servers[0]?.id);

  gameStore
    .apiGetGameHeroes({
      gameSlug: currentGameSlug,
    })
    .then(() => {
      if (gameStore.gameheros.length > 0) {
        checkoutStore.setOneHero({
          championId: gameStore.gameheros[0]?.id,
        });
      }
    });
};

handleDetails();
onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
